import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Stack } from '@mui/system';

export const DrawWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  //   justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  overflowX: 'hidden',
  position: 'relative',
  '::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const DrawGroupWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const DrawButton = styled(Box)(({ theme }) => ({}));

export const GradientBox = (props) => {
  return (
    <Box
      sx={{
        padding: '1.5px',
        position: 'relative',
        background:
          'linear-gradient(225deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.5) 30%,rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.05) 100%)',
        borderRadius: (theme) => theme.typography.pxToRem(12),
      }}
      {...props}
    >
      <Box sx={{ borderRadius: 'inherit' }}>{props.children}</Box>
    </Box>
  );
};

export const DrawItemWrapper = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(212),
  height: theme.typography.pxToRem(212),
  borderRadius: theme.typography.pxToRem(12),
  fontSize: theme.typography.pxToRem(32),
  fontWeight: 700,
  display: 'grid',
  placeContent: 'center',
  background: theme.palette.background.paper,
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: theme.typography.pxToRem(160),
    height: theme.typography.pxToRem(160),
    borderRadius: theme.typography.pxToRem(8),
    fontSize: theme.typography.pxToRem(24),
  },
}));

export const PrizeDisplayItemWrapper = styled(Stack)(({ theme }) => ({
  borderRadius: theme.typography.pxToRem(12),
  background: theme.palette.background.paper,
  aspectRatio: '1/1',
  position: 'relative',

  overflow: 'hidden',
  border: theme.palette.border.normal,
  padding: theme.spacing(2, 1),
}));
